module.exports = __webpack_public_path__ + "static/media/loading.ae2e7bfe.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/loading.gif
// module id = 268
// module chunks = 0 1